import { create } from 'zustand';

export interface SearchStoreType {
    inKeyword: string;
    setInKeyword: (newKeyword: string) => void;
    searchPage: number;
    setSearchPage: (newPage: number) => void;
    myBankTab: 'created' | 'published';
    setMyBankTab: (tab: 'created' | 'published') => void;
}

export const useSearchStore = create<SearchStoreType>((set) => ({
    inKeyword: '',
    setInKeyword: (newKeyword: string) => set({ inKeyword: newKeyword }),
    searchPage: 0,
    setSearchPage: (newPage: number) => set({ searchPage: newPage }),
    myBankTab: 'created',
    setMyBankTab: (tab: 'created' | 'published') => set({ myBankTab: tab }),
}));

export interface CreatedSearchStoreType {
    keyword: string;
    listType: 'card' | 'list';
    selected: number[][];
    filterSelected: number[][];
    openSelected: number[][];
    sortGb: string;
    searchPage: number;
    firstFilterData: DATA.TextbkList[];
    filteredData: API.TextbookMetaCrcuList.TextbookMeta[][];
    setKeyword: (newKeyword: string) => void;
    setListType: (newListType: 'card' | 'list') => void;
    setSelected: (newSelected: number[][]) => void;
    setFilterSelected: (newFilterSelected: number[][]) => void;
    setOpenSelected: (newOpenSelected: number[][]) => void;
    setSortGb: (newSortGb: string) => void;
    setSearchPage: (newPage: number) => void;
    setFirstFilterData: (newFirstFilterData: DATA.TextbkList[]) => void;
    setFilteredData: (newFilteredData: API.TextbookMetaCrcuList.TextbookMeta[][]) => void;
}

export const useCreatedSearchStore = create<CreatedSearchStoreType>((set) => ({
    keyword: '',
    listType: 'card',
    selected: [[], [], [], []],
    filterSelected: [[], [], []],
    openSelected: [[], [], [], []],
    sortGb: '1',
    searchPage: 0,
    firstFilterData: [],
    filteredData: [],
    setKeyword: (newKeyword: string) => set({ keyword: newKeyword }),
    setListType: (newListType: 'card' | 'list') => set({ listType: newListType }),
    setSelected: (newSelected: number[][]) => set({ selected: newSelected }),
    setFilterSelected: (newFilterSelected: number[][]) =>
        set({ filterSelected: newFilterSelected }),
    setOpenSelected: (newOpenSelected: number[][]) => set({ openSelected: newOpenSelected }),
    setSortGb: (newSortGb: string) => set({ sortGb: newSortGb }),
    setSearchPage: (newPage: number) => set({ searchPage: newPage }),
    setFirstFilterData: (newFirstFilterData: DATA.TextbkList[]) =>
        set({ firstFilterData: newFirstFilterData }),
    setFilteredData: (newFilteredData: API.TextbookMetaCrcuList.TextbookMeta[][]) =>
        set({ filteredData: newFilteredData }),
}));
